import { render, staticRenderFns } from "./FileContainer.vue?vue&type=template&id=345e636e&scoped=true&"
import script from "./FileContainer.vue?vue&type=script&lang=js&"
export * from "./FileContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e636e",
  null
  
)

export default component.exports